import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import apiService from '../../services/apiService';

const TikTokCallbackPage = () => {
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');

    if (error) {
      setStatus('error');
      setMessage(params.get('error_description') || 'Authorization was denied');
      return;
    }

    if (!code) {
      setStatus('error');
      setMessage('No authorization code received');
      return;
    }

    exchangeCode(code);
  }, []);

  const exchangeCode = async (code) => {
    try {
      await apiService.connectTikTok(code);
      setStatus('success');
      setMessage('TikTok account connected successfully');

      // Notify parent window
      if (window.opener) {
        window.opener.postMessage({ type: 'tiktok-connected' }, '*');
        setTimeout(() => window.close(), 2000);
      }
    } catch (error) {
      console.error('TikTok token exchange error:', error);
      setStatus('error');
      setMessage(error.message || 'Failed to connect TikTok account');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-sm w-full text-center">
        <img src="/tiktok.png" alt="TikTok" className="w-12 h-12 mx-auto mb-4" />

        {status === 'loading' && (
          <>
            <Loader2 className="w-8 h-8 text-gray-600 animate-spin mx-auto mb-3" />
            <h2 className="text-lg font-semibold text-gray-900">Connecting TikTok...</h2>
            <p className="text-sm text-gray-500 mt-1">Please wait while we verify your account</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-8 h-8 text-green-500 mx-auto mb-3" />
            <h2 className="text-lg font-semibold text-gray-900">Connected!</h2>
            <p className="text-sm text-gray-500 mt-1">{message}</p>
            <p className="text-xs text-gray-400 mt-3">This window will close automatically...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="w-8 h-8 text-red-500 mx-auto mb-3" />
            <h2 className="text-lg font-semibold text-gray-900">Connection Failed</h2>
            <p className="text-sm text-red-600 mt-1">{message}</p>
            <button
              onClick={() => window.close()}
              className="mt-4 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Close Window
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default TikTokCallbackPage;
